import { useState, useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import htmr from 'htmr';
import { useSelector } from 'react-redux';
import classes from './JobDetails.module.scss';
import GeneralInformation from './components/GeneralInformation/GeneralInformation';
import { removeStyleAttribute } from '../../../../utils/helpers';

import ButtonsPanel from '../ButtonsPanel/ButtonsPanel';
import { useWindowSize } from '../../../../utils/hooks';
import BackButton from '../../../common/buttons/BackButton/BackButton';

const JobDetails = ({ job, fullJob = false }) => {
  const ref = useRef(null);
  const topContainerRef = useRef(null);
  const directionRef = useRef(0);
  const { height } = useWindowSize();
  const [fix, setFix] = useState(false);
  const [hideRef, setHideRef] = useState(false);

  const currentJob = fullJob
    ? job
    : useSelector((state) => state.jobs.response.find((jobItem) => jobItem?.Id === job?.Id));

  const isSaving = useSelector((state) => state[fullJob ? 'job' : 'jobs'].pendingSave);

  const wheelHandler = (e) => {
    if (fullJob) return;
    if (ref.current.scrollHeight <= ref.current.clientHeight && e.deltaY < 0 && fix) {
      if (height < 600) {
        hideRef.current.style.height = '70px';
      } else {
        hideRef.current.style.height = currentJob?.IsOpen ? '216px' : '263px';
      }
      setTimeout(() => setFix(false), 600);
    }
  };

  const scrollHandler = (e) => {
    if (ref.current.scrollHeight <= ref.current.clientHeight || fullJob) return;

    if (e.target.scrollTop > directionRef.current && e.target.scrollTop < 5) {
      hideRef.current.style.height = '0px';
      setTimeout(() => setFix(true), 600);
    }

    if (ref.current.scrollTop < 5 && e.target.scrollTop < directionRef.current) {
      if (height < 600) {
        hideRef.current.style.height = '70px';
      } else {
        hideRef.current.style.height = currentJob?.IsOpen ? '216px' : '263px';
      }
      setTimeout(() => setFix(false), 600);
    }

    directionRef.current = e.target.scrollTop;
  };

  useEffect(() => {
    if (hideRef.current && ref.current) {
      if (height < 600) {
        hideRef.current.style.height = '70px';
      } else {
        hideRef.current.style.height = currentJob?.IsOpen ? '216px' : '263px';
      }
      ref.current.scrollTo(0, 0);
      setTimeout(() => setFix(false), 600);
    }
  }, [currentJob?.Id]);

  return job ? (
    <section ref={topContainerRef} className={`${classes.detailsContainer} ${fullJob ? '' : classes.isAsideContainer}`}>
      <Helmet>
        <title>{`${currentJob?.JobTitle} - ${currentJob?.Id} - Airswift`}</title>
      </Helmet>
      {fullJob && (
        <div className="d-flex w-full px-4 pt-4">
          <BackButton />
        </div>
      )}
      <div className={classes.generalInfoWrapper}>
        <GeneralInformation isFullJobOpened={fullJob} job={job} setHideRef={setHideRef} />
      </div>
      <div className={`${classes.buttonsContainer} ${fix ? classes.fixLayout : ''}`}>
        <ButtonsPanel
          fullJob={fullJob}
          job={job}
          isSaved={currentJob?.IsSaved}
          isApplied={currentJob?.IsApplied}
          isOpen={currentJob?.IsOpen}
          isSaving={isSaving}
        />
      </div>
      <hr className={classes.divider} />
      <div
        ref={ref}
        onScroll={scrollHandler}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- keyboard-scrollable region
        tabIndex={0}
        onWheel={wheelHandler}
        className={`${classes.descriptionWrapper} ${!fullJob ? classes.isAside : ''}`}
      >
        {htmr(removeStyleAttribute(job.JobDescription))}
      </div>
    </section>
  ) : (
    ''
  );
};

export default JobDetails;
